export default [
    {
        "name": "Norge",
        "id": ""
    },
    {
        "name": "Oslo",
        "id": "fylke-03"
    }, {
        "name": "Rogaland",
        "id": "fylke-11",
        "kommuner": [
            {
                "name": "Eigersund",
                "id": "kommune-1101"
            },
            {
                "name": "Stavanger",
                "id": "kommune-1103"
            },
            {
                "name": "Haugesund",
                "id": "kommune-1106"
            },
            {
                "name": "Sandnes",
                "id": "kommune-1108"
            },
            {
                "name": "Sokndal",
                "id": "kommune-1111"
            },
            {
                "name": "Lund",
                "id": "kommune-1112"
            },
            {
                "name": "Bjerkreim",
                "id": "kommune-1114"
            },
            {
                "name": "Hå",
                "id": "kommune-1119"
            },
            {
                "name": "Klepp",
                "id": "kommune-1120"
            },
            {
                "name": "Time",
                "id": "kommune-1121"
            },
            {
                "name": "Gjesdal",
                "id": "kommune-1122"
            },
            {
                "name": "Sola",
                "id": "kommune-1124"
            },
            {
                "name": "Randaberg",
                "id": "kommune-1127"
            },
            {
                "name": "Strand",
                "id": "kommune-1130"
            },
            {
                "name": "Hjelmeland",
                "id": "kommune-1133"
            },
            {
                "name": "Suldal",
                "id": "kommune-1134"
            },
            {
                "name": "Sauda",
                "id": "kommune-1135"
            },
            {
                "name": "Kvitsøy",
                "id": "kommune-1144"
            },
            {
                "name": "Bokn",
                "id": "kommune-1145"
            },
            {
                "name": "Tysvær",
                "id": "kommune-1146"
            },
            {
                "name": "Karmøy",
                "id": "kommune-1149"
            },
            {
                "name": "Utsira",
                "id": "kommune-1151"
            },
            {
                "name": "Vindafjord",
                "id": "kommune-1160"
            }
        ]
    },
    {
        "name": "Møre og Romsdal",
        "id": "fylke-15",
        "kommuner": [
            {
                "name": "Kristiansund",
                "id": "kommune-1505"
            },
            {
                "name": "Molde",
                "id": "kommune-1506"
            },
            {
                "name": "Ålesund",
                "id": "kommune-1508"
            },
            {
                "name": "Vanylven",
                "id": "kommune-1511"
            },
            {
                "name": "Sande",
                "id": "kommune-1514"
            },
            {
                "name": "Herøy",
                "id": "kommune-1515"
            },
            {
                "name": "Ulstein",
                "id": "kommune-1516"
            },
            {
                "name": "Hareid",
                "id": "kommune-1517"
            },
            {
                "name": "Ørsta",
                "id": "kommune-1520"
            },
            {
                "name": "Stranda",
                "id": "kommune-1525"
            },
            {
                "name": "Sykkylven",
                "id": "kommune-1528"
            },
            {
                "name": "Sula",
                "id": "kommune-1531"
            },
            {
                "name": "Giske",
                "id": "kommune-1532"
            },
            {
                "name": "Vestnes",
                "id": "kommune-1535"
            },
            {
                "name": "Rauma",
                "id": "kommune-1539"
            },
            {
                "name": "Aukra",
                "id": "kommune-1547"
            },
            {
                "name": "Averøy",
                "id": "kommune-1554"
            },
            {
                "name": "Gjemnes",
                "id": "kommune-1557"
            },
            {
                "name": "Tingvoll",
                "id": "kommune-1560"
            },
            {
                "name": "Sunndal",
                "id": "kommune-1563"
            },
            {
                "name": "Surnadal",
                "id": "kommune-1566"
            },
            {
                "name": "Smøla",
                "id": "kommune-1573"
            },
            {
                "name": "Aure",
                "id": "kommune-1576"
            },
            {
                "name": "Volda",
                "id": "kommune-1577"
            },
            {
                "name": "Fjord",
                "id": "kommune-1578"
            },
            {
                "name": "Hustadvika",
                "id": "kommune-1579"
            },
            {
                "name": "Haram",
                "id": "kommune-1580"
            }
        ]
    },
    {
        "name": "Nordland",
        "id": "fylke-18",
        "kommuner": [
            {
                "name": "Andøy",
                "id": "kommune-1871"
            },
            {
                "name": "Sømna",
                "id": "kommune-1812"
            },
            {
                "name": "Brønnøy",
                "id": "kommune-1813"
            },
            {
                "name": "Vega",
                "id": "kommune-1815"
            },
            {
                "name": "Vevelstad",
                "id": "kommune-1816"
            },
            {
                "name": "Hábmer",
                "id": "kommune-1875"
            },
            {
                "name": "Steigen",
                "id": "kommune-1848"
            },
            {
                "name": "Lødingen",
                "id": "kommune-1851"
            },
            {
                "name": "Evenes",
                "id": "kommune-1853"
            },
            {
                "name": "Bodø",
                "id": "kommune-1804"
            },
            {
                "name": "Narvik",
                "id": "kommune-1806"
            },
            {
                "name": "Bindal",
                "id": "kommune-1811"
            },
            {
                "name": "Herøy",
                "id": "kommune-1818"
            },
            {
                "name": "Alstahaug",
                "id": "kommune-1820"
            },
            {
                "name": "Leirfjord",
                "id": "kommune-1822"
            },
            {
                "name": "Vefsn",
                "id": "kommune-1824"
            },
            {
                "name": "Grane",
                "id": "kommune-1825"
            },
            {
                "name": "Aarborte",
                "id": "kommune-1826"
            },
            {
                "name": "Dønna",
                "id": "kommune-1827"
            },
            {
                "name": "Nesna",
                "id": "kommune-1828"
            },
            {
                "name": "Hemnes",
                "id": "kommune-1832"
            },
            {
                "name": "Rana",
                "id": "kommune-1833"
            },
            {
                "name": "Lurøy",
                "id": "kommune-1834"
            },
            {
                "name": "Træna",
                "id": "kommune-1835"
            },
            {
                "name": "Rødøy",
                "id": "kommune-1836"
            },
            {
                "name": "Meløy",
                "id": "kommune-1837"
            },
            {
                "name": "Gildeskål",
                "id": "kommune-1838"
            },
            {
                "name": "Beiarn",
                "id": "kommune-1839"
            },
            {
                "name": "Saltdal",
                "id": "kommune-1840"
            },
            {
                "name": "Fauske",
                "id": "kommune-1841"
            },
            {
                "name": "Sørfold",
                "id": "kommune-1845"
            },
            {
                "name": "Røst",
                "id": "kommune-1856"
            },
            {
                "name": "Værøy",
                "id": "kommune-1857"
            },
            {
                "name": "Vestvågøy",
                "id": "kommune-1860"
            },
            {
                "name": "Flakstad",
                "id": "kommune-1859"
            },
            {
                "name": "Vågan",
                "id": "kommune-1865"
            },
            {
                "name": "Hadsel",
                "id": "kommune-1866"
            },
            {
                "name": "Bø",
                "id": "kommune-1867"
            },
            {
                "name": "Øksnes",
                "id": "kommune-1868"
            },
            {
                "name": "Sortland",
                "id": "kommune-1870"
            },
            {
                "name": "Moskenes",
                "id": "kommune-1874"
            }
        ]
    },
    {
        "name": "Østfold",
        "id": "fylke-31",
        "kommuner": [
            {
                "name": "Skiptvet",
                "id": "kommune-3116"
            },
            {
                "name": "Indre Østfold",
                "id": "kommune-3118"
            },
            {
                "name": "Halden",
                "id": "kommune-3101"
            },
            {
                "name": "Moss",
                "id": "kommune-3103"
            },
            {
                "name": "Sarpsborg",
                "id": "kommune-3105"
            },
            {
                "name": "Fredrikstad",
                "id": "kommune-3107"
            },
            {
                "name": "Hvaler",
                "id": "kommune-3110"
            },
            {
                "name": "Råde",
                "id": "kommune-3112"
            },
            {
                "name": "Våler",
                "id": "kommune-3114"
            },
            {
                "name": "Rakkestad",
                "id": "kommune-3120"
            },
            {
                "name": "Marker",
                "id": "kommune-3122"
            },
            {
                "name": "Aremark",
                "id": "kommune-3124"
            }
        ]
    },
    {
        "name": "Akershus",
        "id": "fylke-32",
        "kommuner": [
            {
                "name": "Bærum",
                "id": "kommune-3201"
            },
            {
                "name": "Asker",
                "id": "kommune-3203"
            },
            {
                "name": "Lillestrøm",
                "id": "kommune-3205"
            },
            {
                "name": "Nordre Follo",
                "id": "kommune-3207"
            },
            {
                "name": "Ullensaker",
                "id": "kommune-3209"
            },
            {
                "name": "Nesodden",
                "id": "kommune-3212"
            },
            {
                "name": "Frogn",
                "id": "kommune-3214"
            },
            {
                "name": "Vestby",
                "id": "kommune-3216"
            },
            {
                "name": "Ås",
                "id": "kommune-3218"
            },
            {
                "name": "Enebakk",
                "id": "kommune-3220"
            },
            {
                "name": "Lørenskog",
                "id": "kommune-3222"
            },
            {
                "name": "Rælingen",
                "id": "kommune-3224"
            },
            {
                "name": "Aurskog-Høland",
                "id": "kommune-3226"
            },
            {
                "name": "Nes",
                "id": "kommune-3228"
            },
            {
                "name": "Gjerdrum",
                "id": "kommune-3230"
            },
            {
                "name": "Nittedal",
                "id": "kommune-3232"
            },
            {
                "name": "Lunner",
                "id": "kommune-3234"
            },
            {
                "name": "Jevnaker",
                "id": "kommune-3236"
            },
            {
                "name": "Nannestad",
                "id": "kommune-3238"
            },
            {
                "name": "Eidsvoll",
                "id": "kommune-3240"
            },
            {
                "name": "Hurdal",
                "id": "kommune-3242"
            }
        ]
    },
    {
        "name": "Buskerud",
        "id": "fylke-33",
        "kommuner": [
            {
                "name": "Drammen",
                "id": "kommune-3301"
            },
            {
                "name": "Kongsberg",
                "id": "kommune-3303"
            },
            {
                "name": "Ringerike",
                "id": "kommune-3305"
            },
            {
                "name": "Hole",
                "id": "kommune-3310"
            },
            {
                "name": "Lier",
                "id": "kommune-3312"
            },
            {
                "name": "Øvre Eiker",
                "id": "kommune-3314"
            },
            {
                "name": "Modum",
                "id": "kommune-3316"
            },
            {
                "name": "Krødsherad",
                "id": "kommune-3318"
            },
            {
                "name": "Flå",
                "id": "kommune-3320"
            },
            {
                "name": "Nesbyen",
                "id": "kommune-3322"
            },
            {
                "name": "Gol",
                "id": "kommune-3324"
            },
            {
                "name": "Hemsedal",
                "id": "kommune-3326"
            },
            {
                "name": "Ål",
                "id": "kommune-3328"
            },
            {
                "name": "Hol",
                "id": "kommune-3330"
            },
            {
                "name": "Sigdal",
                "id": "kommune-3332"
            },
            {
                "name": "Flesberg",
                "id": "kommune-3334"
            },
            {
                "name": "Rollag",
                "id": "kommune-3336"
            },
            {
                "name": "Nore og Uvdal",
                "id": "kommune-3338"
            }
        ]
    },
    {
        "name": "Innlandet",
        "id": "fylke-34",
        "kommuner": [
            {
                "name": "Dovre",
                "id": "kommune-3431"
            },
            {
                "name": "Kongsvinger",
                "id": "kommune-3401"
            },
            {
                "name": "Hamar",
                "id": "kommune-3403"
            },
            {
                "name": "Lillehammer",
                "id": "kommune-3405"
            },
            {
                "name": "Gjøvik",
                "id": "kommune-3407"
            },
            {
                "name": "Ringsaker",
                "id": "kommune-3411"
            },
            {
                "name": "Løten",
                "id": "kommune-3412"
            },
            {
                "name": "Stange",
                "id": "kommune-3413"
            },
            {
                "name": "Nord-Odal",
                "id": "kommune-3414"
            },
            {
                "name": "Sør-Odal",
                "id": "kommune-3415"
            },
            {
                "name": "Eidskog",
                "id": "kommune-3416"
            },
            {
                "name": "Grue",
                "id": "kommune-3417"
            },
            {
                "name": "Åsnes",
                "id": "kommune-3418"
            },
            {
                "name": "Våler",
                "id": "kommune-3419"
            },
            {
                "name": "Elverum",
                "id": "kommune-3420"
            },
            {
                "name": "Trysil",
                "id": "kommune-3421"
            },
            {
                "name": "Åmot",
                "id": "kommune-3422"
            },
            {
                "name": "Stor-Elvdal",
                "id": "kommune-3423"
            },
            {
                "name": "Rendalen",
                "id": "kommune-3424"
            },
            {
                "name": "Engerdal",
                "id": "kommune-3425"
            },
            {
                "name": "Tolga",
                "id": "kommune-3426"
            },
            {
                "name": "Tynset",
                "id": "kommune-3427"
            },
            {
                "name": "Alvdal",
                "id": "kommune-3428"
            },
            {
                "name": "Folldal",
                "id": "kommune-3429"
            },
            {
                "name": "Os",
                "id": "kommune-3430"
            },
            {
                "name": "Lesja",
                "id": "kommune-3432"
            },
            {
                "name": "Skjåk",
                "id": "kommune-3433"
            },
            {
                "name": "Lom",
                "id": "kommune-3434"
            },
            {
                "name": "Vågå",
                "id": "kommune-3435"
            },
            {
                "name": "Nord-Fron",
                "id": "kommune-3436"
            },
            {
                "name": "Sel",
                "id": "kommune-3437"
            },
            {
                "name": "Sør-Fron",
                "id": "kommune-3438"
            },
            {
                "name": "Ringebu",
                "id": "kommune-3439"
            },
            {
                "name": "Øyer",
                "id": "kommune-3440"
            },
            {
                "name": "Gausdal",
                "id": "kommune-3441"
            },
            {
                "name": "Østre Toten",
                "id": "kommune-3442"
            },
            {
                "name": "Vestre Toten",
                "id": "kommune-3443"
            },
            {
                "name": "Gran",
                "id": "kommune-3446"
            },
            {
                "name": "Søndre Land",
                "id": "kommune-3447"
            },
            {
                "name": "Nordre Land",
                "id": "kommune-3448"
            },
            {
                "name": "Sør-Aurdal",
                "id": "kommune-3449"
            },
            {
                "name": "Etnedal",
                "id": "kommune-3450"
            },
            {
                "name": "Nord-Aurdal",
                "id": "kommune-3451"
            },
            {
                "name": "Vestre Slidre",
                "id": "kommune-3452"
            },
            {
                "name": "Øystre Slidre",
                "id": "kommune-3453"
            },
            {
                "name": "Vang",
                "id": "kommune-3454"
            }
        ]
    },
    {
        "name": "Vestfold",
        "id": "fylke-39",
        "kommuner": [
            {
                "name": "Horten",
                "id": "kommune-3901"
            },
            {
                "name": "Holmestrand",
                "id": "kommune-3903"
            },
            {
                "name": "Tønsberg",
                "id": "kommune-3905"
            },
            {
                "name": "Sandefjord",
                "id": "kommune-3907"
            },
            {
                "name": "Larvik",
                "id": "kommune-3909"
            },
            {
                "name": "Færder",
                "id": "kommune-3911"
            }
        ]
    },
    {
        "name": "Telemark",
        "id": "fylke-40",
        "kommuner": [
            {
                "name": "Hjartdal",
                "id": "kommune-4024"
            },
            {
                "name": "Tinn",
                "id": "kommune-4026"
            },
            {
                "name": "Kviteseid",
                "id": "kommune-4028"
            },
            {
                "name": "Nissedal",
                "id": "kommune-4030"
            },
            {
                "name": "Fyresdal",
                "id": "kommune-4032"
            },
            {
                "name": "Porsgrunn",
                "id": "kommune-4001"
            },
            {
                "name": "Skien",
                "id": "kommune-4003"
            },
            {
                "name": "Notodden",
                "id": "kommune-4005"
            },
            {
                "name": "Siljan",
                "id": "kommune-4010"
            },
            {
                "name": "Bamble",
                "id": "kommune-4012"
            },
            {
                "name": "Kragerø",
                "id": "kommune-4014"
            },
            {
                "name": "Drangedal",
                "id": "kommune-4016"
            },
            {
                "name": "Nome",
                "id": "kommune-4018"
            },
            {
                "name": "Midt-Telemark",
                "id": "kommune-4020"
            },
            {
                "name": "Seljord",
                "id": "kommune-4022"
            },
            {
                "name": "Tokke",
                "id": "kommune-4034"
            },
            {
                "name": "Vinje",
                "id": "kommune-4036"
            }
        ]
    },
    {
        "name": "Agder",
        "id": "fylke-42",
        "kommuner": [
            {
                "name": "Risør",
                "id": "kommune-4201"
            },
            {
                "name": "Grimstad",
                "id": "kommune-4202"
            },
            {
                "name": "Arendal",
                "id": "kommune-4203"
            },
            {
                "name": "Kristiansand",
                "id": "kommune-4204"
            },
            {
                "name": "Lindesnes",
                "id": "kommune-4205"
            },
            {
                "name": "Farsund",
                "id": "kommune-4206"
            },
            {
                "name": "Flekkefjord",
                "id": "kommune-4207"
            },
            {
                "name": "Gjerstad",
                "id": "kommune-4211"
            },
            {
                "name": "Vegårshei",
                "id": "kommune-4212"
            },
            {
                "name": "Tvedestrand",
                "id": "kommune-4213"
            },
            {
                "name": "Froland",
                "id": "kommune-4214"
            },
            {
                "name": "Lillesand",
                "id": "kommune-4215"
            },
            {
                "name": "Birkenes",
                "id": "kommune-4216"
            },
            {
                "name": "Åmli",
                "id": "kommune-4217"
            },
            {
                "name": "Iveland",
                "id": "kommune-4218"
            },
            {
                "name": "Evje og Hornnes",
                "id": "kommune-4219"
            },
            {
                "name": "Bygland",
                "id": "kommune-4220"
            },
            {
                "name": "Valle",
                "id": "kommune-4221"
            },
            {
                "name": "Bykle",
                "id": "kommune-4222"
            },
            {
                "name": "Vennesla",
                "id": "kommune-4223"
            },
            {
                "name": "Åseral",
                "id": "kommune-4224"
            },
            {
                "name": "Lyngdal",
                "id": "kommune-4225"
            },
            {
                "name": "Hægebostad",
                "id": "kommune-4226"
            },
            {
                "name": "Kvinesdal",
                "id": "kommune-4227"
            },
            {
                "name": "Sirdal",
                "id": "kommune-4228"
            }
        ]
    },
    {
        "name": "Vestland",
        "id": "fylke-46",
        "kommuner": [
            {
                "name": "Bergen",
                "id": "kommune-4601"
            },
            {
                "name": "Kinn",
                "id": "kommune-4602"
            },
            {
                "name": "Etne",
                "id": "kommune-4611"
            },
            {
                "name": "Bømlo",
                "id": "kommune-4613"
            },
            {
                "name": "Tysnes",
                "id": "kommune-4616"
            },
            {
                "name": "Kvinnherad",
                "id": "kommune-4617"
            },
            {
                "name": "Ullensvang",
                "id": "kommune-4618"
            },
            {
                "name": "Eidfjord",
                "id": "kommune-4619"
            },
            {
                "name": "Ulvik",
                "id": "kommune-4620"
            },
            {
                "name": "Voss",
                "id": "kommune-4621"
            },
            {
                "name": "Sveio",
                "id": "kommune-4612"
            },
            {
                "name": "Kvam",
                "id": "kommune-4622"
            },
            {
                "name": "Samnanger",
                "id": "kommune-4623"
            },
            {
                "name": "Stord",
                "id": "kommune-4614"
            },
            {
                "name": "Bjørnafjorden",
                "id": "kommune-4624"
            },
            {
                "name": "Fedje",
                "id": "kommune-4633"
            },
            {
                "name": "Fitjar",
                "id": "kommune-4615"
            },
            {
                "name": "Austevoll",
                "id": "kommune-4625"
            },
            {
                "name": "Øygarden",
                "id": "kommune-4626"
            },
            {
                "name": "Askøy",
                "id": "kommune-4627"
            },
            {
                "name": "Vaksdal",
                "id": "kommune-4628"
            },
            {
                "name": "Modalen",
                "id": "kommune-4629"
            },
            {
                "name": "Osterøy",
                "id": "kommune-4630"
            },
            {
                "name": "Alver",
                "id": "kommune-4631"
            },
            {
                "name": "Austrheim",
                "id": "kommune-4632"
            },
            {
                "name": "Masfjorden",
                "id": "kommune-4634"
            },
            {
                "name": "Gulen",
                "id": "kommune-4635"
            },
            {
                "name": "Solund",
                "id": "kommune-4636"
            },
            {
                "name": "Hyllestad",
                "id": "kommune-4637"
            },
            {
                "name": "Høyanger",
                "id": "kommune-4638"
            },
            {
                "name": "Vik",
                "id": "kommune-4639"
            },
            {
                "name": "Sogndal",
                "id": "kommune-4640"
            },
            {
                "name": "Aurland",
                "id": "kommune-4641"
            },
            {
                "name": "Lærdal",
                "id": "kommune-4642"
            },
            {
                "name": "Årdal",
                "id": "kommune-4643"
            },
            {
                "name": "Luster",
                "id": "kommune-4644"
            },
            {
                "name": "Askvoll",
                "id": "kommune-4645"
            },
            {
                "name": "Fjaler",
                "id": "kommune-4646"
            },
            {
                "name": "Sunnfjord",
                "id": "kommune-4647"
            },
            {
                "name": "Stad",
                "id": "kommune-4649"
            },
            {
                "name": "Gloppen",
                "id": "kommune-4650"
            },
            {
                "name": "Stryn",
                "id": "kommune-4651"
            },
            {
                "name": "Bremanger",
                "id": "kommune-4648"
            }
        ]
    },
    {
        "name": "Trøndelag",
        "id": "fylke-50",
        "kommuner": [
            {
                "name": "Trondheim",
                "id": "kommune-5001"
            },
            {
                "name": "Steinkjer",
                "id": "kommune-5006"
            },
            {
                "name": "Namsos",
                "id": "kommune-5007"
            },
            {
                "name": "Frøya",
                "id": "kommune-5014"
            },
            {
                "name": "Osen",
                "id": "kommune-5020"
            },
            {
                "name": "Oppdal",
                "id": "kommune-5021"
            },
            {
                "name": "Rennebu",
                "id": "kommune-5022"
            },
            {
                "name": "Rosse",
                "id": "kommune-5025"
            },
            {
                "name": "Holtålen",
                "id": "kommune-5026"
            },
            {
                "name": "Midtre Gauldal",
                "id": "kommune-5027"
            },
            {
                "name": "Melhus",
                "id": "kommune-5028"
            },
            {
                "name": "Skaun",
                "id": "kommune-5029"
            },
            {
                "name": "Malvik",
                "id": "kommune-5031"
            },
            {
                "name": "Selbu",
                "id": "kommune-5032"
            },
            {
                "name": "Tydal",
                "id": "kommune-5033"
            },
            {
                "name": "Meråker",
                "id": "kommune-5034"
            },
            {
                "name": "Stjørdal",
                "id": "kommune-5035"
            },
            {
                "name": "Frosta",
                "id": "kommune-5036"
            },
            {
                "name": "Levanger",
                "id": "kommune-5037"
            },
            {
                "name": "Verdal",
                "id": "kommune-5038"
            },
            {
                "name": "Snåase",
                "id": "kommune-5041"
            },
            {
                "name": "Lierne",
                "id": "kommune-5042"
            },
            {
                "name": "Høylandet",
                "id": "kommune-5046"
            },
            {
                "name": "Overhalla",
                "id": "kommune-5047"
            },
            {
                "name": "Flatanger",
                "id": "kommune-5049"
            },
            {
                "name": "Heim",
                "id": "kommune-5055"
            },
            {
                "name": "Raarvihke",
                "id": "kommune-5043"
            },
            {
                "name": "Namsskogan",
                "id": "kommune-5044"
            },
            {
                "name": "Grong",
                "id": "kommune-5045"
            },
            {
                "name": "Leka",
                "id": "kommune-5052"
            },
            {
                "name": "Inderøy",
                "id": "kommune-5053"
            },
            {
                "name": "Indre Fosen",
                "id": "kommune-5054"
            },
            {
                "name": "Hitra",
                "id": "kommune-5056"
            },
            {
                "name": "Ørland",
                "id": "kommune-5057"
            },
            {
                "name": "Åfjord",
                "id": "kommune-5058"
            },
            {
                "name": "Orkland",
                "id": "kommune-5059"
            },
            {
                "name": "Nærøysund",
                "id": "kommune-5060"
            },
            {
                "name": "Rindal",
                "id": "kommune-5061"
            }
        ]
    },
    {
        "name": "Troms",
        "id": "fylke-55",
        "kommuner": [
            {
                "name": "Loabák",
                "id": "kommune-5518"
            },
            {
                "name": "Bardu",
                "id": "kommune-5520"
            },
            {
                "name": "Salangen",
                "id": "kommune-5522"
            },
            {
                "name": "Målselv",
                "id": "kommune-5524"
            },
            {
                "name": "Sørreisa",
                "id": "kommune-5526"
            },
            {
                "name": "Tromsø",
                "id": "kommune-5501"
            },
            {
                "name": "Harstad",
                "id": "kommune-5503"
            },
            {
                "name": "Kvæfjord",
                "id": "kommune-5510"
            },
            {
                "name": "Dielddanuorri",
                "id": "kommune-5512"
            },
            {
                "name": "Ibestad",
                "id": "kommune-5514"
            },
            {
                "name": "Gratangen",
                "id": "kommune-5516"
            },
            {
                "name": "Dyrøy",
                "id": "kommune-5528"
            },
            {
                "name": "Senja",
                "id": "kommune-5530"
            },
            {
                "name": "Balsfjord",
                "id": "kommune-5532"
            },
            {
                "name": "Karlsøy",
                "id": "kommune-5534"
            },
            {
                "name": "Lyngen",
                "id": "kommune-5536"
            },
            {
                "name": "Storfjord",
                "id": "kommune-5538"
            },
            {
                "name": "Gáivuotna",
                "id": "kommune-5540"
            },
            {
                "name": "Skjervøy",
                "id": "kommune-5542"
            },
            {
                "name": "Nordreisa",
                "id": "kommune-5544"
            },
            {
                "name": "Kvænangen",
                "id": "kommune-5546"
            }
        ]
    },
    {
        "name": "Finnmark",
        "id": "fylke-56",
        "kommuner": [
            {
                "name": "Måsøy",
                "id": "kommune-5618"
            },
            {
                "name": "Nordkapp",
                "id": "kommune-5620"
            },
            {
                "name": "Alta",
                "id": "kommune-5601"
            },
            {
                "name": "Hammerfest",
                "id": "kommune-5603"
            },
            {
                "name": "Sør-Varanger",
                "id": "kommune-5605"
            },
            {
                "name": "Vadsø",
                "id": "kommune-5607"
            },
            {
                "name": "Kárášjohka",
                "id": "kommune-5610"
            },
            {
                "name": "Guovdageaidnu",
                "id": "kommune-5612"
            },
            {
                "name": "Loppa",
                "id": "kommune-5614"
            },
            {
                "name": "Hasvik",
                "id": "kommune-5616"
            },
            {
                "name": "Porsanger",
                "id": "kommune-5622"
            },
            {
                "name": "Lebesby",
                "id": "kommune-5624"
            },
            {
                "name": "Gamvik",
                "id": "kommune-5626"
            },
            {
                "name": "Deatnu",
                "id": "kommune-5628"
            },
            {
                "name": "Berlevåg",
                "id": "kommune-5630"
            },
            {
                "name": "Båtsfjord",
                "id": "kommune-5632"
            },
            {
                "name": "Vardø",
                "id": "kommune-5634"
            },
            {
                "name": "Unjárga",
                "id": "kommune-5636"
            }
        ]
    }
]
